define(
	'C3.ShoppingExtensions.VisualSystemPage.SubcategoryItem.View',
	[
		//'SCView', 
		'c3_shoppingextensions_visualsystempage_subcategoryitem.tpl',
		'item_relations_cell.tpl',
		'item_relations_row.tpl',
		'Backbone.CollectionView',
		'facets_item_cell_grid.tpl',
	    'facets_items_collection_view_cell.tpl',
	    'facets_items_collection_view_row.tpl',
	    'facets_items_collection.tpl',
	    'Utils',
	    'C3.ShoppingExtensions.VisualSystemPage.SubcategoryItem.CellView',
	    'c3_shoppingextensions_visualsystempage_subcategoryitem_main.tpl'
	],
	function(
		//SCViewComponent, 
		c3_shoppingextensions_visualsystempage_subcategoryitem_tpl,
		item_relations_cell_tpl,
		item_relations_row_tpl,
		BackboneCollectionView,
		facets_item_cell_grid_tpl,
	    facets_items_collection_view_cell_tpl,
	    facets_items_collection_view_row_tpl,
	    facets_items_collection_tpl,
	    Utils,
	    VisualSystemPageItemCell,
	    c3_shoppingextensions_visualsystempage_subcategoryitem_main_tpl
		) {
		'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_visualsystempage_subcategoryitem_tpl

	,	initialize: function (options) {
		    this.options = options;
			
			var self = this;

			this.application = options.application;
			this.configuration = options.configuration;
			this.categoryiteminfo = options.categoryiteminfo;

			this.subCatNames = options.subcatnames;

			//console.log(this.subCatNames);
			//console.log(this.categoryiteminfo.internalid)

			this.iteminfo = this.categoryiteminfo.itemsearchapi
			this.itemsInSubcat = this.iteminfo.items;
			this.currentpagepath = options.currentpagepath;

			var findCurrentSubCatName = _.findWhere(this.subCatNames,{'id' : this.categoryiteminfo.internalid})
			//console.log(findCurrentSubCatName);

			this.currentCategoryName = findCurrentSubCatName.name;
			//this.once('afterCompositeViewRender', this.initSlider, this);
		}

	/*,   initSlider: function initSlider() {

			var self = this;
	        if(jQuery(window).width() >= 760) //using 760 due to Tablet as its showing to start from 760
            {
           // const { siteSettings } = this.application.getConfig();
            	
           // setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');
                //console.log(carousel)
                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (jQuery(window).width() >= 760 && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }
                

                bxSliderDefaults.slideWidth = 283;
                bxSliderDefaults.maxSlides = 5;
                bxSliderDefaults.hideControlOnEnd = true;
                bxSliderDefaults.prevText = '<a class="home-gallery-prev-icon"></a>';
                bxSliderDefaults.nextText = '<a class="home-gallery-next-icon"></a>';
                //bxSliderDefaults.touchEnabled = false;
                
                bxSliderDefaults.infiniteLoop = false;
                console.log(bxSliderDefaults)
                Utils.initBxSlider(carousel, bxSliderDefaults);
             // });
            }
    }	*/

	,	bindings: {
		}


	, 	childViews: {
			'VisualSystemSubcategoryItems.Cell': function ()
      		{
     			var self = this;
     			var categoryInfo = this.categoryiteminfo;	
     			//console.log(this.itemsInSubcat)
     			return new BackboneCollectionView({
		                application: this.application,
		                collection: this.itemsInSubcat,
		                viewsPerRow: Infinity,
		                childView: VisualSystemPageItemCell,
		                cellTemplate: item_relations_cell_tpl,
	            		rowTemplate: item_relations_row_tpl,
		                template: c3_shoppingextensions_visualsystempage_subcategoryitem_main_tpl,
			            childViewOptions: {
		                    origin: this.origin ? this.origin : categoryInfo.internalid+'-visualsystem-page',
		                    hideArrows : this.itemsInSubcat.length <= 4 ? true : false,
		                    application : this.application,
		                    container : this.container,
		                    configuration : this.configuration,
		                    currentpagepath : this.currentpagepath
		                }
            		});

      		}
		}
	

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			var categoryInfo = this.categoryiteminfo;	
			return {
				name: this.currentCategoryName,
				items : this.itemsInSubcat,
				hideArrows : this.itemsInSubcat.length <= 4 ? true : false/*,
				categoryId : categoryInfo.internalid+'-visualsystem-page'*/
			};
		}
	});
});
